import { lazy, Suspense } from 'react';
import { Outlet } from 'react-router-dom';

import { SplashScreen } from 'src/components/loading-screen';

import { GuestGuard } from 'src/auth/guard';

// ----------------------------------------------------------------------

/** **************************************
 * Jwt
 *************************************** */
const Jwt = {
  SignInPage: lazy(() => import('src/pages/auth/jwt/sign-in')),
  ForgetPasswordPage: lazy(() => import('src/pages/auth/jwt/forget-password')),
  FairSignUpPage: lazy(() => import('src/pages/auth/jwt/fair-signup')),
  JudgeSignUpPage: lazy(() => import('src/pages/auth/jwt/judge-signup')),
  GeneralUserPage: lazy(() => import('src/pages/auth/jwt/general-user')),
  ResetNewPasswordPage: lazy(() => import('src/pages/auth/jwt/reset-new-password')),
  InitiatePasswordPage: lazy(() => import('src/pages/auth/jwt/initiate-password')),
};

const authJwt = {
  children: [
    {
      path: 'sign-in',
      element: (
        <GuestGuard>
          <Jwt.SignInPage />
        </GuestGuard>
      ),
    },
    {
      path: 'forget-password',
      element: (
        <GuestGuard>
          <Jwt.ForgetPasswordPage />
        </GuestGuard>
      ),
    },
    {
      path: 'general-user-signup',
      element: (
        <GuestGuard>
          <Jwt.GeneralUserPage />
        </GuestGuard>
      ),
    },
    {
      path: 'fair-signup',
      element: (
        <GuestGuard>
          <Jwt.FairSignUpPage />
        </GuestGuard>
      ),
    },
    {
      path: 'reset-new-password',
      element: (
        <GuestGuard>
          <Jwt.ResetNewPasswordPage />
        </GuestGuard>
      ),
    },
    {
      path: 'judge-signup',
      element: (
        <GuestGuard>
          <Jwt.JudgeSignUpPage />
        </GuestGuard>
      ),
    },
    {
      path: 'initiate-password',
      element: (
        <GuestGuard>
          <Jwt.InitiatePasswordPage />
        </GuestGuard>
      ),
    }
  ],
};

// ----------------------------------------------------------------------

export const authRoutes = [
  {
    path: 'auth',
    element: (
      <Suspense fallback={<SplashScreen />}>
        <Outlet />
      </Suspense>
    ),
    children: [authJwt],
  },
];
